import { css } from '@emotion/react'

export const sidebarSkeletonItemContainer = (height: number) => css`
  height: ${height}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
